(() => {
  const init = (root) => {
    if (!root || root.dataset.ginShimasaReady === 'true') return;
    root.dataset.ginShimasaReady = 'true';
    const form = root.querySelector('[data-gin-shimasa-product-form]');
    if (!form) return;
    const age = form.querySelector('.age-confirmation-checkbox');
    const button = form.querySelector('[data-add-to-cart]');
    if (!age || !button) return;
    const unavailable = button.dataset.productUnavailable === 'true';
    const sync = () => { button.disabled = unavailable || !age.checked; };
    age.addEventListener('change', sync);
    form.addEventListener('submit', (event) => {
      if (unavailable || !age.checked) {
        event.preventDefault();
        return;
      }
      button.disabled = true;
    });
    sync();
  };
  const initAll = () => document.querySelectorAll('.gin-shimasa-lp').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true }); else initAll();
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.gin-shimasa-lp')));
})();
